import React from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Table,
  Spinner,
  Row,
  Col,
  Button,
} from 'reactstrap';

import moment from 'moment';
//Simple bar
import SimpleBar from 'simplebar-react';

//Import Image
import avatar4 from '../../../../assets/images/avatar_male.png';

const PensionComponent = ({
  options = [],
  height = '695px',
  loading = true,
  title = 'Daftar Pegawai Akan Pensiun Tahun Ini',
  linkdata = null,
  dataexport = null,
}) => {
  const dateParse = (input) => {
    let res = '-';
    if (input !== '' && input != null) {
      res = moment(input).format('DD/MM/YYYY');
    }
    return res;
  };

  return (
    <React.Fragment>
      <Card
        className="overflow-auto"
        style={{
          height: '93%',
          borderRadius: '20px',
          boxShadow:
            '-2px 2px 4px 2px rgba(0, 0, 0, 0.1), 1px 1px 3px 1px rgba(0, 0, 0, 0.1)',
        }}
      >
        <CardBody>
          <CardTitle>
            <Row>
              <Col lg="9">{title}</Col>
              <Col lg="3" className="float-right">
                {loading === false ? (
                  <div className="text-end">
                    <Button
                      className="btn btn-success btn-sm float-right"
                      value="jenis_kelamin"
                    >
                      <a
                        href={linkdata + dataexport}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'white' }}
                      >
                        <i className="fa fa-download"></i> export
                      </a>
                    </Button>
                  </div>
                ) : (
                  ''
                )}
              </Col>
            </Row>
          </CardTitle>
          <SimpleBar style={{ maxHeight: '336px' }}>
            {loading === false ? (
              <div className="table-responsive">
                <Table className="table-borderless table-centered">
                  <tbody>
                    {options.length > 0 ? (
                      options.map((data, index) => {
                        return (
                          <tr key={`tr-${index}`}>
                            <td style={{ width: '20px' }}>
                              <img
                                src={avatar4}
                                className="avatar-xs rounded-circle "
                                alt="..."
                              />
                            </td>
                            <td>
                              <h6 className="font-size-15 mb-1 fw-normal">
                                {data.employee_name}
                              </h6>
                              <p className="font-size-10 mb-0">
                                <span>
                                  <i className="mdi mdi-calendar-arrow-left"></i>{' '}
                                  Tanggal Lahir : {data.employee_date_of_birth}
                                </span>
                              </p>
                              <p className="font-size-10 mb-0">
                                <span className="text-danger">
                                  <i className="mdi mdi-calendar-arrow-left"></i>{' '}
                                  Tanggal Pensiun :{' '}
                                  {data.decree_cpns_decree_tmt}
                                </span>
                              </p>
                            </td>
                            <td className="text-muted fw-semibold text-end"></td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="2">Tidak Ada Pegawai Pensiun Tahun Ini</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="text-center" style={{ marginTop: '105px' }}>
                <Spinner className="m-2" color="primary" />
              </div>
            )}
          </SimpleBar>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default PensionComponent;
